export default "__VITE_ASSET__D4bsad7G__"